module.exports = __webpack_public_path__ + "img/acess.85148d6f.svg";